import { Trans, useTranslation } from 'react-i18next'
import { Box, useTheme, FormLabel } from '@mui/material'
import { Device, DeviceHwID } from '../../types/models'
import { ListSelector } from '../atoms/ListSelector'
import { Cable, Wifi } from '@mui/icons-material'

export interface SelectRadioFormProps {
  master: DeviceHwID | ''
  masters: Device[]
  onChange: (master: DeviceHwID | '') => void
  disabled?: boolean
}

export function SelectRadioForm(props: SelectRadioFormProps) {
  const { master, masters, onChange, disabled } = props
  const theme = useTheme()
  const { t } = useTranslation()

  const items: Array<[string, string]> = [['', t('Device connected with Ethernet cable')]]
  masters.forEach(m => items.push([m.hw_id, t('Radio through master {hwId}').replace('{hwId}', m.hw_id)]))

  if (masters.length === 0) {
    return <></>
  }

  return (
    <Box sx={{ mt: 5, mb: 2, color: theme.palette.statsText.main }}>
      <FormLabel><Trans>Radio options:</Trans></FormLabel>
      <ListSelector
        items={[items[0]]}
        disabled={disabled}
        icons={[Cable]}
        selected={master}
        onSelect={(e) => onChange(e as DeviceHwID)}
      />
      <Trans>If you want to connect through radio, select radio master below. In this case only the master is allowed to use Ethernet cable.</Trans>
      <ListSelector
        items={[...items.slice(1)]}
        disabled={disabled}
        icons={masters.map(_ => Wifi)}
        selected={master}
        onSelect={(e) => onChange(e as DeviceHwID)}
      />
    </Box>
  )
}
